import {Lookup} from '../../shared-components/lookup/lookup.model';
import {TylerMatTableDataSource} from '../../shared-components/angular-material/extended.class';
import {GPFilterParam} from './gp-filter-param';
import * as _ from 'lodash';

export class GradPlanTypeModel extends Lookup {

	// Server Properties
	GraduationPlans: GraduationPlanModel[];
	RowNumber: number;
	Definition: string;
	IsExpanded: boolean;

	// Local Properties
	private _tableData = new TylerMatTableDataSource();
	private previousGradPlanStatus = [];

	// Methods
	getTableData(gpFilterParam: GPFilterParam) {
		// PRE: the filter parameters
		// POST: returns a filtered data source
		if (!_.isEqual(this.previousGradPlanStatus, gpFilterParam.GradPlanStatus)) {
			this._tableData.data = this.GraduationPlans.filter(gradPlan => {
				if (!gpFilterParam.GradPlanStatus || gpFilterParam.GradPlanStatus.includes('all')) {
					return true;
				} else {
					return gpFilterParam.GradPlanStatus.includes(gradPlan.Status);
				}
			});
			this.previousGradPlanStatus = _.clone(gpFilterParam.GradPlanStatus);
		}
		return this._tableData;
	}
}

export class GraduationPlanModel {

	// Server Properties
	SubjectAreas: GradPlanSubjectAreaModel[];
	RowNumber: number;
	GradPlan_ID: number;
	IsAssigned: boolean;
    IsPrimary: boolean;
    PlanType: string;
    PlanCategory: string;
	GradPlanName: string;
	DeclarationDate: string;
	ParentSigReceived: string;
	GraduationYear: string;
	GraduationBasis: string;
	Overridden: boolean;
	Required: number;
	Attempted: number;
	Earned: number;
	Current: number;
	Requested: number;
	Over: number;
	Need: number;
	Status: string;
	IsExpanded: boolean;
	AddedBy: string;
	AddedOn: Date;

	// Local Properties
	private _tableData = new TylerMatTableDataSource();
	private previousSubjectAreaStatus = [];

	// Methods
	getTableData(gpFilterParam: GPFilterParam) {
		// PRE: the filter parameters
		// POST: returns a filtered data source
		if (!_.isEqual(this.previousSubjectAreaStatus, gpFilterParam.SubjectAreaStatus)) {
			this._tableData.data = this.SubjectAreas.filter(gradPlan => {
				if (!gpFilterParam.SubjectAreaStatus || gpFilterParam.SubjectAreaStatus.includes('all')) {
					return true;
				} else {
					return gpFilterParam.SubjectAreaStatus.includes(gradPlan.Status);
				}
			});
			this.previousSubjectAreaStatus = _.clone(gpFilterParam.SubjectAreaStatus);
		}
		return this._tableData;
	}
}

export class GradPlanSubjectAreaModel {

	// Server Properties
	CreditCodes: GradPlanCreditCodeModel[];
	RowNumber: number;
	SubjectArea: string;
	Required: number;
	Attempted: number;
	Earned: number;
	Current: number;
	Requested: number;
	Over: number;
	Need: number;
	Status: string;
	IsExpanded: boolean;

	// Local Properties
	private _tableData = new TylerMatTableDataSource();
	private previousCreditCodeStatus = [];

	// Methods
	getTableData(gpFilterParam: GPFilterParam) {
		// PRE: the filter parameters
		// POST: returns a filtered data source
		if (!_.isEqual(this.previousCreditCodeStatus, gpFilterParam.CreditCodeStatus)) {
			this._tableData.data = this.CreditCodes.filter(gradPlan => {
				if (!gpFilterParam.CreditCodeStatus || gpFilterParam.CreditCodeStatus.includes('all')) {
					return true;
				} else {
					return gpFilterParam.CreditCodeStatus.includes(gradPlan.Status);
				}
			});
			this.previousCreditCodeStatus = _.clone(gpFilterParam.CreditCodeStatus);
		}
		return this._tableData;
	}
}

export class GradPlanCreditCodeModel {

	// Server Properties
	Courses: GradPlanCoursesModel[];
	RowNumber: number;
	CreditCode: string;
	Overridden: boolean;
	Required: number;
	Attempted: number;
	Earned: number;
	Current: number;
	Requested: number;
	Over: number;
	Need: number;
	Status: string;
	IsExpanded: boolean;

	// Local Properties
	private _tableData = new TylerMatTableDataSource();
	private previousCourseStatus = [];

	// Methods
	getTableData(gpFilterParam: GPFilterParam) {
		// PRE: the filter parameters
		// POST: returns a filtered data source
		if (!_.isEqual(this.previousCourseStatus, gpFilterParam.CourseStatus)) {
			this._tableData.data = this.Courses.filter(course => {
				if (!gpFilterParam.CourseStatus || gpFilterParam.CourseStatus.includes('all')) {
					return true;
				} else {
					return gpFilterParam.CourseStatus.includes(course.Status);
				}
			});
			this.previousCourseStatus = _.clone(gpFilterParam.CourseStatus);
		}
		return this._tableData;
	}
}

export class GradPlanCoursesModel {
	RowNumber: number;
	GradPlan_ID: number;
	SSEC_ID: number;
	DataBucketScore_ID: number;
	Course_ID: number;
	Course: string;
	Overridden: boolean;
	Attempted: number;
	Earned: number;
	Current: number;
	Requested: number;
	Status: string;
	IsExpanded: boolean;
}

export class GPStudentNCourseInfoModel {
	RowNumber: number;
	StudentName: string;
	StudentNumberIdentifier: string;
	SubjectIdentifier: string;
	SubjectName: string;
	SectionName: string;
	CreditCode: string;
	OverrideCreditCode: string;
}